export * from './validator.directive';
export * from './type.validators';
export * from './matcher.directive';
export * from './amount.validator';
export * from './iban.validator';
export * from './email.validator';
export * from './phone.validator';
export * from './max-value';
export * from './min-value';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/index.ts